// extracted by mini-css-extract-plugin
export default {"contactInput":"contact_contactInput__aMpX1","contactMessage":"contact_contactMessage__ONFLu"};